// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Wings Assistant Chat Component Styles */
.wings-assistant-chat {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}
.wings-assistant-chat .chat-toggle-button-container {
  position: relative;
  display: inline-block;
}
.wings-assistant-chat .news-bubble {
  position: absolute;
  bottom: 70px;
  right: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 12px 16px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.4);
  cursor: pointer;
  animation: bounceIn 0.5s ease, floatBubble 3s ease-in-out infinite;
  min-width: 220px;
  max-width: 280px;
  z-index: 10009;
}
.wings-assistant-chat .news-bubble .news-bubble-content {
  display: flex;
  align-items: center;
  gap: 10px;
}
.wings-assistant-chat .news-bubble .news-bubble-content i {
  font-size: 18px;
  animation: sparkle 1.5s ease-in-out infinite;
}
.wings-assistant-chat .news-bubble .news-bubble-content span {
  font-size: 13px;
  font-weight: 500;
  line-height: 1.4;
}
.wings-assistant-chat .news-bubble .news-bubble-close {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #ff4757;
  border: 2px solid white;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 10px;
  transition: transform 0.2s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
.wings-assistant-chat .news-bubble .news-bubble-close:hover {
  transform: scale(1.1);
  background: #ff3344;
}
.wings-assistant-chat .news-bubble .news-bubble-arrow {
  position: absolute;
  bottom: -8px;
  right: 25px;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #764ba2;
}
.wings-assistant-chat .chat-toggle-button {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #1ab394, #13806a);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  position: relative;
}
.wings-assistant-chat .chat-toggle-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.2);
}
.wings-assistant-chat .chat-toggle-button.shake-animation {
  animation: shake 0.8s ease-in-out infinite;
}
.wings-assistant-chat .chat-toggle-button i {
  color: #fff;
  font-size: 24px;
}
.wings-assistant-chat .chat-toggle-button .chat-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background: #ff4757;
  color: #fff;
  border-radius: 50%;
  min-width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  animation: pulse 2s infinite;
}
.wings-assistant-chat .chat-window {
  position: relative;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.2);
  width: 400px;
  height: 600px;
  min-width: 300px;
  min-height: 50px;
  max-width: 90vw;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: slideInUp 0.3s ease;
  transition: height 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
}
.wings-assistant-chat .chat-window.chat-resizing {
  transition: none !important;
  resize: both;
}
.wings-assistant-chat .chat-window wings-chat-header {
  width: 100%;
  z-index: 30;
  flex-shrink: 0;
}
@media (max-width: 768px) {
  .wings-assistant-chat .chat-window {
    width: 95vw !important;
    height: 70vh !important;
    bottom: 10px;
    right: 10px;
  }
}
.wings-assistant-chat .chat-window .chat-layout {
  display: flex;
  height: calc(100% - 50px);
  width: 100%;
  flex: 1;
  overflow: hidden;
  transition: opacity 0.3s ease, height 0.3s ease;
}
.wings-assistant-chat .chat-window .chat-layout.minimized {
  height: 0;
  opacity: 0;
}
.wings-assistant-chat .chat-window .chat-layout .chat-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}
.wings-assistant-chat .chat-window .chat-layout .chat-main .chat-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #fafafa;
  width: 100%;
  position: relative;
}
.wings-assistant-chat .chat-window .chat-header {
  background: linear-gradient(135deg, #1ab394, #13806a);
  color: #fff;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 50px;
  height: 50px;
  flex-shrink: 0;
  width: 100%;
  box-sizing: border-box;
}
.wings-assistant-chat .chat-window .chat-header .chat-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 16px;
  flex-shrink: 0;
}
.wings-assistant-chat .chat-window .chat-header .chat-title i {
  font-size: 18px;
  flex-shrink: 0;
}
.wings-assistant-chat .chat-window .chat-header .chat-title span {
  white-space: nowrap;
}
.wings-assistant-chat .chat-messages {
  flex: 1;
  padding: 16px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #fafafa;
}
.wings-assistant-chat .chat-messages::-webkit-scrollbar {
  width: 6px;
}
.wings-assistant-chat .chat-messages::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}
.wings-assistant-chat .chat-messages::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}
.wings-assistant-chat .chat-messages::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}
.wings-assistant-chat .message {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  animation: fadeInUp 0.3s ease;
  max-width: 90%;
}
.wings-assistant-chat .message.user-message {
  align-self: flex-end;
  flex-direction: row-reverse;
}
.wings-assistant-chat .message.user-message .message-content {
  background: linear-gradient(135deg, #1ab394, #13806a);
  color: #fff;
  border-radius: 18px 18px 4px 18px;
  box-shadow: 0 2px 8px rgba(19, 128, 106, 0.25);
  padding: 10px;
}
.wings-assistant-chat .message.user-message .message-avatar {
  background: #1ab394;
}
.wings-assistant-chat .message.assistant-message {
  align-self: flex-start;
}
.wings-assistant-chat .message.assistant-message .message-content {
  background: #fff;
  color: #333;
  border: 1px solid #e1e5e9;
  border-radius: 18px 18px 18px 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.wings-assistant-chat .message.assistant-message .message-avatar {
  background: #6c757d;
}
.wings-assistant-chat .message .message-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.wings-assistant-chat .message .message-avatar i {
  color: #fff;
  font-size: 16px;
}
.wings-assistant-chat .message .message-content {
  padding: 12px 16px;
  word-wrap: break-word;
  max-width: calc(100% - 48px);
}
.wings-assistant-chat .message .message-content .message-text {
  margin: 0;
  line-height: 1.5;
  font-size: 14px;
}
.wings-assistant-chat .message .message-content .message-text p {
  margin: 0 0 8px;
}
.wings-assistant-chat .message .message-content .message-text p:last-child {
  margin-bottom: 0;
}
.wings-assistant-chat .message .message-content .message-text pre {
  background: rgba(0, 0, 0, 0.05);
  padding: 8px;
  border-radius: 6px;
  overflow-x: auto;
  margin: 8px 0;
}
.wings-assistant-chat .message .message-content .message-text code {
  font-family: monospace;
  background: rgba(0, 0, 0, 0.05);
  padding: 2px 4px;
  border-radius: 3px;
}
.wings-assistant-chat .message .message-content .message-text ul, .wings-assistant-chat .message .message-content .message-text ol {
  padding-left: 24px;
  margin: 8px 0;
}
.wings-assistant-chat .message .message-content .message-time {
  font-size: 11px;
  opacity: 0.7;
  margin-top: 6px;
  text-align: right;
}
.wings-assistant-chat .typing-indicator {
  display: flex;
  align-items: center;
}
.wings-assistant-chat .typing-indicator span {
  margin-right: 8px;
  font-size: 13px;
  color: #666;
}
.wings-assistant-chat .typing-indicator .typing-dots {
  display: flex;
  gap: 4px;
  padding: 4px 8px;
}
.wings-assistant-chat .typing-indicator .typing-dots span {
  width: 8px;
  height: 8px;
  margin: 0;
  background: #1ab394;
  border-radius: 50%;
  opacity: 0.7;
  animation: typing 1.4s infinite ease-in-out;
}
.wings-assistant-chat .typing-indicator .typing-dots span:nth-child(1) {
  animation-delay: 0s;
}
.wings-assistant-chat .typing-indicator .typing-dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.wings-assistant-chat .typing-indicator .typing-dots span:nth-child(3) {
  animation-delay: 0.4s;
}
.wings-assistant-chat .chat-input {
  padding: 12px 16px;
  border-top: 1px solid #e1e5e9;
  background: #fff;
  flex-shrink: 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.03);
  position: relative;
  z-index: 10;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}
.wings-assistant-chat .chat-input .input-container, .wings-assistant-chat .chat-input .input-container-chat {
  display: flex;
  gap: 8px;
  align-items: center;
  background: #f8f9fa;
  border-radius: 24px;
  padding: 6px 6px 6px 16px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.06), inset 0 1px 0 rgba(255, 255, 255, 0.9);
  border: 1px solid #e0e4e8;
  transition: all 0.2s ease-out;
}
.wings-assistant-chat .chat-input .input-container textarea.message-input, .wings-assistant-chat .chat-input .input-container-chat textarea.message-input {
  flex: 1;
  padding: 10px 12px;
  border: none;
  border-radius: 24px;
  outline: none;
  resize: none;
  font-size: 14px;
  min-height: 20px;
  max-height: 100px;
  overflow-y: auto;
  font-family: inherit;
  line-height: 1.4;
  background: transparent;
  margin: 0;
  align-self: center;
}
.wings-assistant-chat .chat-input .input-container textarea.message-input:focus, .wings-assistant-chat .chat-input .input-container-chat textarea.message-input:focus {
  outline: none;
  box-shadow: none;
}
.wings-assistant-chat .chat-input .input-container textarea.message-input:disabled, .wings-assistant-chat .chat-input .input-container-chat textarea.message-input:disabled {
  background: #f9f9f9;
  cursor: not-allowed;
  border-radius: 24px 0 0 24px;
  opacity: 0.7;
}
.wings-assistant-chat .chat-input .input-container textarea.message-input::placeholder, .wings-assistant-chat .chat-input .input-container-chat textarea.message-input::placeholder {
  color: #9ca3af;
  opacity: 0.8;
}
.wings-assistant-chat .chat-input .input-container .send-button, .wings-assistant-chat .chat-input .input-container-chat .send-button {
  width: 40px;
  height: 40px;
  min-width: 40px;
  background: linear-gradient(135deg, #1ab394, #13806a);
  border: none;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.wings-assistant-chat .chat-input .input-container .send-button:hover:not(:disabled), .wings-assistant-chat .chat-input .input-container-chat .send-button:hover:not(:disabled) {
  filter: brightness(1.1);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
.wings-assistant-chat .chat-input .input-container .send-button:active:not(:disabled), .wings-assistant-chat .chat-input .input-container-chat .send-button:active:not(:disabled) {
  transform: scale(0.95);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
.wings-assistant-chat .chat-input .input-container .send-button:disabled, .wings-assistant-chat .chat-input .input-container-chat .send-button:disabled {
  background: #d1d5db;
  cursor: not-allowed;
  box-shadow: none;
}
.wings-assistant-chat .chat-input .input-container .send-button i, .wings-assistant-chat .chat-input .input-container-chat .send-button i {
  font-size: 16px;
  position: relative;
  left: 1px;
}
.wings-assistant-chat .chat-input .input-container.expired, .wings-assistant-chat .chat-input .input-container-chat.expired {
  position: relative;
}
.wings-assistant-chat .chat-input .input-container.expired .expired-overlay, .wings-assistant-chat .chat-input .input-container-chat.expired .expired-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  z-index: 5;
  border-radius: 24px;
  padding: 6px 12px;
  font-size: 13px;
  color: #6b7280;
}
.wings-assistant-chat .chat-input .input-container.expired .expired-overlay i.fa-clock-o, .wings-assistant-chat .chat-input .input-container-chat.expired .expired-overlay i.fa-clock-o {
  color: #f59e0b;
  font-size: 15px;
}
.wings-assistant-chat .chat-input .input-container.expired .expired-overlay .expired-new-chat-btn, .wings-assistant-chat .chat-input .input-container-chat.expired .expired-overlay .expired-new-chat-btn {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: #fff;
  border: none;
  border-radius: 16px;
  padding: 4px 12px;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  transition: filter 0.2s;
}
.wings-assistant-chat .chat-input .input-container.expired .expired-overlay .expired-new-chat-btn:hover, .wings-assistant-chat .chat-input .input-container-chat.expired .expired-overlay .expired-new-chat-btn:hover {
  filter: brightness(1.1);
}
.wings-assistant-chat.chat-fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
}
.wings-assistant-chat.chat-fullscreen .chat-window {
  width: 100% !important;
  height: 100% !important;
  max-width: none !important;
  max-height: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}
.wings-assistant-chat.chat-fullscreen .chat-window .chat-layout {
  height: 100%;
}
.wings-assistant-chat.chat-resizing .chat-window {
  transition: none !important;
}

.wings-assistant-chat.chat-open .chat-toggle-button {
  display: none;
}

.wings-assistant-chat.chat-minimized .chat-window {
  height: 64px !important;
  min-height: 64px !important;
  max-height: 64px !important;
  overflow: hidden;
  transition: height 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
}
.wings-assistant-chat.chat-minimized .chat-window wings-chat-header {
  display: block;
}
.wings-assistant-chat.chat-minimized .chat-window .chat-layout {
  opacity: 0;
  height: 0;
  overflow: hidden;
  visibility: hidden;
}

.system-message {
  background-color: rgba(26, 179, 148, 0.05);
  border-left: 3px solid #1ab394;
}
.system-message .message-avatar i {
  color: #1ab394;
}
.system-message .loading-indicator {
  display: flex;
  align-items: center;
  padding: 5px;
}
.system-message .loading-indicator span {
  margin-left: 8px;
  color: #333;
  font-style: italic;
}

.message-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 6px;
  font-size: 12px;
}
.message-footer .message-feedback {
  display: flex;
  align-items: center;
  gap: 8px;
}
.message-footer .message-feedback .feedback-button {
  background: none;
  border: none;
  color: #777;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: all 0.2s ease;
}
.message-footer .message-feedback .feedback-button:hover:not(.disabled) {
  background: #f0f0f0;
  color: #1ab394;
}
.message-footer .message-feedback .feedback-button.disabled {
  cursor: default;
  color: #1ab394;
  opacity: 0.8;
}
.message-footer .message-feedback .feedback-button:disabled {
  cursor: default;
  color: #1ab394;
  opacity: 0.8;
}
.message-footer .message-feedback .feedback-button i {
  font-size: 14px;
}
.message-footer .message-feedback .feedback-sent {
  color: #1ab394;
  display: flex;
  align-items: center;
}
.message-footer .message-feedback .feedback-sent i {
  font-size: 14px;
}

.feedback-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10099;
  animation: fadeIn 0.2s ease;
}
.feedback-modal .feedback-modal-content {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  animation: scaleIn 0.2s ease;
}
.feedback-modal .feedback-modal-content .feedback-modal-header {
  padding: 16px;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.feedback-modal .feedback-modal-content .feedback-modal-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}
.feedback-modal .feedback-modal-content .feedback-modal-header .close-button {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #777;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.feedback-modal .feedback-modal-content .feedback-modal-header .close-button:hover {
  background: #f5f5f5;
}
.feedback-modal .feedback-modal-content .feedback-modal-body {
  padding: 16px;
}
.feedback-modal .feedback-modal-content .feedback-modal-body .feedback-rating {
  margin-bottom: 20px;
}
.feedback-modal .feedback-modal-content .feedback-modal-body .feedback-rating p {
  margin-bottom: 10px;
}
.feedback-modal .feedback-modal-content .feedback-modal-body .feedback-rating .star-rating {
  display: flex;
  gap: 8px;
}
.feedback-modal .feedback-modal-content .feedback-modal-body .feedback-rating .star-rating .star-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #d0d0d0;
  padding: 0;
  transition: transform 0.2s ease;
}
.feedback-modal .feedback-modal-content .feedback-modal-body .feedback-rating .star-rating .star-button:hover {
  transform: scale(1.2);
}
.feedback-modal .feedback-modal-content .feedback-modal-body .feedback-rating .star-rating .star-button.active {
  color: #ffc107;
  animation: pulse 0.3s ease;
}
.feedback-modal .feedback-modal-content .feedback-modal-body .feedback-comment p {
  margin-bottom: 10px;
}
.feedback-modal .feedback-modal-content .feedback-modal-body .feedback-comment .feedback-textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-family: inherit;
  resize: vertical;
}
.feedback-modal .feedback-modal-content .feedback-modal-body .feedback-comment .feedback-textarea:focus {
  outline: none;
  border-color: #1ab394;
  box-shadow: 0 0 0 2px rgba(26, 179, 148, 0.2);
}
.feedback-modal .feedback-modal-content .feedback-modal-footer {
  padding: 16px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.feedback-modal .feedback-modal-content .feedback-modal-footer button {
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.feedback-modal .feedback-modal-content .feedback-modal-footer button.cancel-button {
  background: #f5f5f5;
  border: 1px solid #ddd;
  color: #333;
}
.feedback-modal .feedback-modal-content .feedback-modal-footer button.cancel-button:hover {
  background: #e5e5e5;
}
.feedback-modal .feedback-modal-content .feedback-modal-footer button.submit-button {
  background: #1ab394;
  border: 1px solid #13806a;
  color: white;
}
.feedback-modal .feedback-modal-content .feedback-modal-footer button.submit-button:hover {
  background: #13806a;
}
.feedback-modal .feedback-modal-content .feedback-modal-footer button.submit-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.feedback-modal .feedback-modal-content .feedback-modal-footer button.submit-button.loading {
  position: relative;
  padding-left: 30px;
}
.feedback-modal .feedback-modal-content .feedback-modal-footer button.submit-button.loading i {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes scaleIn {
  from {
    transform: scale(0.9);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes typing {
  0%, 100% {
    transform: translateY(0);
    opacity: 0.6;
  }
  50% {
    transform: translateY(-6px);
    opacity: 1;
  }
}
@keyframes shake {
  0%, 100% {
    transform: rotate(0deg);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: rotate(-5deg);
  }
  20%, 40%, 60%, 80% {
    transform: rotate(5deg);
  }
}
@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3) translateY(20px);
  }
  50% {
    transform: scale(1.05) translateY(-5px);
  }
  70% {
    transform: scale(0.95) translateY(2px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
@keyframes floatBubble {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}
@keyframes sparkle {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.1);
  }
}
@media (max-width: 480px) {
  .wings-assistant-chat {
    bottom: 10px;
    right: 10px;
  }
  .wings-assistant-chat .chat-toggle-button {
    width: 56px;
    height: 56px;
  }
  .wings-assistant-chat .chat-toggle-button i {
    font-size: 22px;
  }
  .wings-assistant-chat .chat-window {
    width: calc(100vw - 20px);
    height: calc(100vh - 100px);
    border-radius: 12px 12px 0 0;
  }
}
@media (max-width: 600px) {
  .wings-assistant-chat .chat-header {
    padding: 12px 16px;
  }
  .wings-assistant-chat .chat-header .chat-title {
    font-size: 14px;
  }
  .wings-assistant-chat .chat-header .chat-title i {
    font-size: 16px;
  }
  .wings-assistant-chat .chat-header .chat-title span {
    display: none;
  }
  .wings-assistant-chat .chat-header .chat-actions {
    gap: 4px;
  }
  .wings-assistant-chat .chat-header .chat-actions .action-btn {
    min-width: 28px;
    height: 28px;
    padding: 4px;
  }
  .wings-assistant-chat .chat-header .chat-actions .action-btn i {
    font-size: 12px;
  }
  .wings-assistant-chat .chat-controls {
    top: 8px;
    right: 12px;
  }
  .wings-assistant-chat .chat-controls .control-btn {
    width: 28px;
    height: 28px;
  }
  .wings-assistant-chat .chat-controls .control-btn i {
    font-size: 12px;
  }
}
.attachments-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 12px;
  background: #f8f9fa;
  border-bottom: 1px solid #e1e5e9;
  max-height: 150px;
  overflow-y: auto;
}
.attachments-preview .attachment-item {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  border: 1px solid #e1e5e9;
  border-radius: 8px;
  padding: 6px 10px;
  max-width: 200px;
  min-width: 120px;
  position: relative;
  transition: all 0.2s ease;
  animation: fadeInUp 0.2s ease;
}
.attachments-preview .attachment-item:hover {
  border-color: #1ab394;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.attachments-preview .attachment-item:hover .attachment-remove {
  opacity: 1;
}
.attachments-preview .attachment-item .attachment-thumbnail {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
}
.attachments-preview .attachment-item .attachment-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.attachments-preview .attachment-item .attachment-icon {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  background: linear-gradient(135deg, #f0f0f0, #e0e0e0);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.attachments-preview .attachment-item .attachment-icon i {
  font-size: 16px;
  color: #666;
}
.attachments-preview .attachment-item .attachment-icon i.fa-file-pdf-o {
  color: #e74c3c;
}
.attachments-preview .attachment-item .attachment-icon i.fa-file-excel-o {
  color: #27ae60;
}
.attachments-preview .attachment-item .attachment-icon i.fa-file-word-o {
  color: #2980b9;
}
.attachments-preview .attachment-item .attachment-icon i.fa-file-image-o {
  color: #9b59b6;
}
.attachments-preview .attachment-item .attachment-icon i.fa-file-text-o {
  color: #7f8c8d;
}
.attachments-preview .attachment-item .attachment-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.attachments-preview .attachment-item .attachment-info .attachment-name {
  font-size: 12px;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.attachments-preview .attachment-item .attachment-info .attachment-size {
  font-size: 10px;
  color: #999;
}
.attachments-preview .attachment-item .attachment-remove {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #ff4757;
  border: 2px solid #fff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
.attachments-preview .attachment-item .attachment-remove:hover {
  background: #ff3344;
  transform: scale(1.1);
}
.attachments-preview .attachment-item .attachment-remove i {
  font-size: 10px;
}

.attachment-button {
  width: 36px;
  height: 36px;
  min-width: 36px;
  background: transparent;
  border: none;
  border-radius: 50%;
  color: #6b7280;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s ease;
  margin-right: 4px;
}
.attachment-button:hover:not(:disabled) {
  background: rgba(26, 179, 148, 0.1);
  color: #1ab394;
}
.attachment-button:active:not(:disabled) {
  transform: scale(0.95);
}
.attachment-button:disabled {
  color: #d1d5db;
  cursor: not-allowed;
}
.attachment-button i {
  font-size: 18px;
  transform: rotate(-45deg);
}

.hidden-file-input {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  pointer-events: none;
}

@media (max-width: 480px) {
  .attachments-preview {
    max-height: 120px;
  }
  .attachments-preview .attachment-item {
    max-width: 160px;
    min-width: 100px;
    padding: 4px 8px;
  }
  .attachments-preview .attachment-item .attachment-thumbnail,
  .attachments-preview .attachment-item .attachment-icon {
    width: 28px;
    height: 28px;
  }
  .attachments-preview .attachment-item .attachment-info .attachment-name {
    font-size: 11px;
  }
  .attachments-preview .attachment-item .attachment-info .attachment-size {
    font-size: 9px;
  }
  .attachments-preview .attachment-item .attachment-remove {
    width: 18px;
    height: 18px;
    top: -5px;
    right: -5px;
  }
  .attachments-preview .attachment-item .attachment-remove i {
    font-size: 9px;
  }
  .attachment-button {
    width: 32px;
    height: 32px;
    min-width: 32px;
  }
  .attachment-button i {
    font-size: 16px;
  }
}
.suggestions-dropdown {
  position: absolute;
  bottom: 100%;
  left: 16px;
  right: 16px;
  margin-bottom: 8px;
  background: #fff;
  border: 1px solid #e1e5e9;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  z-index: 20;
  animation: slideUpFade 0.2s ease;
}
.suggestions-dropdown .suggestions-list {
  max-height: 200px;
  overflow-y: auto;
}
.suggestions-dropdown .suggestions-list::-webkit-scrollbar {
  width: 4px;
}
.suggestions-dropdown .suggestions-list::-webkit-scrollbar-track {
  background: transparent;
}
.suggestions-dropdown .suggestions-list::-webkit-scrollbar-thumb {
  background: #d0d0d0;
  border-radius: 2px;
}
.suggestions-dropdown .suggestion-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  cursor: pointer;
  transition: all 0.15s ease;
  border-bottom: 1px solid #f0f0f0;
}
.suggestions-dropdown .suggestion-item:last-child {
  border-bottom: none;
}
.suggestions-dropdown .suggestion-item:hover, .suggestions-dropdown .suggestion-item.selected {
  background: rgba(26, 179, 148, 0.08);
}
.suggestions-dropdown .suggestion-item.selected {
  background: rgba(26, 179, 148, 0.12);
  border-left: 3px solid #1ab394;
  padding-left: 13px;
}
.suggestions-dropdown .suggestion-item i {
  font-size: 14px;
  color: #1ab394;
  flex-shrink: 0;
  width: 20px;
  text-align: center;
}
.suggestions-dropdown .suggestion-item .suggestion-text {
  font-size: 13px;
  color: #333;
  line-height: 1.4;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.suggestions-dropdown .suggestions-hint {
  display: flex;
  justify-content: center;
  gap: 16px;
  padding: 8px 12px;
  background: #f8f9fa;
  border-top: 1px solid #e1e5e9;
  font-size: 11px;
  color: #888;
}
.suggestions-dropdown .suggestions-hint span {
  display: flex;
  align-items: center;
  gap: 4px;
}
.suggestions-dropdown .suggestions-hint kbd {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  background: #fff;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  font-family: inherit;
  font-size: 10px;
  color: #555;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);
}

@keyframes slideUpFade {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.chat-content .chat-input {
  position: relative;
}

.news-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10199;
  animation: fadeIn 0.3s ease;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}
.news-modal-overlay .news-modal {
  background: #fff;
  border-radius: 16px;
  width: 90%;
  max-width: 550px;
  max-height: 85vh;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: scaleIn 0.3s ease;
  display: flex;
  flex-direction: column;
}
.news-modal-overlay .news-modal .news-modal-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
  color: white !important;
}
.news-modal-overlay .news-modal .news-modal-header .news-header-icon {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.news-modal-overlay .news-modal .news-modal-header .news-header-icon i {
  font-size: 24px;
}
.news-modal-overlay .news-modal .news-modal-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  flex: 1;
}
.news-modal-overlay .news-modal .news-modal-header .news-modal-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}
.news-modal-overlay .news-modal .news-modal-header .news-modal-close:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: rotate(90deg);
}
.news-modal-overlay .news-modal .news-modal-header .news-modal-close i {
  font-size: 14px;
}
.news-modal-overlay .news-modal .news-modal-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1;
}
.news-modal-overlay .news-modal .news-modal-body .news-intro {
  margin-bottom: 24px;
}
.news-modal-overlay .news-modal .news-modal-body .news-intro .news-highlight {
  font-size: 15px;
  line-height: 1.6;
  color: #333;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1));
  padding: 16px;
  border-radius: 12px;
  border-left: 4px solid #667eea;
  margin-bottom: 12px;
}
.news-modal-overlay .news-modal .news-modal-body .news-intro p {
  font-size: 14px;
  line-height: 1.6;
  color: #555;
  margin: 0;
}
.news-modal-overlay .news-modal .news-modal-body .news-section h3 {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}
.news-modal-overlay .news-modal .news-modal-body .news-section h3 i {
  color: #1ab394;
}
.news-modal-overlay .news-modal .news-modal-body .news-section .news-feature {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
  padding: 16px;
  background: #f9fafb;
  border-radius: 12px;
  transition: all 0.2s ease;
}
.news-modal-overlay .news-modal .news-modal-body .news-section .news-feature:hover {
  background: #f3f4f6;
  transform: translateX(4px);
}
.news-modal-overlay .news-modal .news-modal-body .news-section .news-feature .feature-icon {
  width: 44px;
  height: 44px;
  background: linear-gradient(135deg, #1ab394, #13806a);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.news-modal-overlay .news-modal .news-modal-body .news-section .news-feature .feature-icon i {
  color: #fff;
  font-size: 18px;
}
.news-modal-overlay .news-modal .news-modal-body .news-section .news-feature .feature-content {
  flex: 1;
}
.news-modal-overlay .news-modal .news-modal-body .news-section .news-feature .feature-content h4 {
  margin: 0 0 8px 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}
.news-modal-overlay .news-modal .news-modal-body .news-section .news-feature .feature-content p {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #666;
}
.news-modal-overlay .news-modal .news-modal-body .news-section .news-feature .feature-content ul {
  margin: 8px 0 0 0;
  padding-left: 20px;
}
.news-modal-overlay .news-modal .news-modal-body .news-section .news-feature .feature-content ul li {
  font-size: 12px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 4px;
}
.news-modal-overlay .news-modal .news-modal-body .news-cta {
  margin-top: 20px;
  padding: 16px;
  background: linear-gradient(135deg, rgba(26, 179, 148, 0.1), rgba(19, 128, 106, 0.1));
  border-radius: 12px;
  text-align: center;
}
.news-modal-overlay .news-modal .news-modal-body .news-cta p {
  margin: 0 0 8px 0;
  font-size: 14px;
  line-height: 1.5;
  color: #333;
}
.news-modal-overlay .news-modal .news-modal-body .news-cta .news-signature {
  margin-top: 12px;
  font-size: 14px;
  color: #666;
}
.news-modal-overlay .news-modal .news-modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #e1e5e9;
  display: flex;
  justify-content: center;
}
.news-modal-overlay .news-modal .news-modal-footer .news-start-button {
  padding: 12px 32px;
  background: linear-gradient(135deg, #1ab394, #13806a);
  border: none;
  border-radius: 25px;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(26, 179, 148, 0.4);
}
.news-modal-overlay .news-modal .news-modal-footer .news-start-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(26, 179, 148, 0.5);
}
.news-modal-overlay .news-modal .news-modal-footer .news-start-button:active {
  transform: translateY(0);
}
.news-modal-overlay .news-modal .news-modal-footer .news-start-button i {
  font-size: 18px;
}

@media (max-width: 480px) {
  .news-modal-overlay .news-modal {
    width: 95%;
    max-height: 90vh;
    border-radius: 12px;
  }
  .news-modal-overlay .news-modal .news-modal-header {
    padding: 16px 20px;
  }
  .news-modal-overlay .news-modal .news-modal-header .news-header-icon {
    width: 40px;
    height: 40px;
  }
  .news-modal-overlay .news-modal .news-modal-header .news-header-icon i {
    font-size: 20px;
  }
  .news-modal-overlay .news-modal .news-modal-header h2 {
    font-size: 16px;
  }
  .news-modal-overlay .news-modal .news-modal-body {
    padding: 16px;
  }
  .news-modal-overlay .news-modal .news-modal-body .news-section .news-feature {
    flex-direction: column;
    gap: 12px;
  }
  .news-modal-overlay .news-modal .news-modal-body .news-section .news-feature .feature-icon {
    width: 36px;
    height: 36px;
  }
  .news-modal-overlay .news-modal .news-modal-body .news-section .news-feature .feature-icon i {
    font-size: 16px;
  }
  .suggestions-dropdown {
    left: 8px;
    right: 8px;
  }
  .suggestions-dropdown .suggestion-item {
    padding: 10px 12px;
  }
  .suggestions-dropdown .suggestion-item .suggestion-text {
    font-size: 12px;
  }
  .suggestions-dropdown .suggestions-hint {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/angularApp/components/wings-assistant-chat/wings-assistant-chat.scss"],"names":[],"mappings":"AAAA,0CAAA;AAyBA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,aANa;EAOb,8EAAA;AAvBF;AA0BE;EACE,kBAAA;EACA,qBAAA;AAxBJ;AA4BE;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,6DAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,+CAAA;EACA,eAAA;EACA,kEAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AA1BJ;AA4BI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA1BN;AA4BM;EACE,eAAA;EACA,4CAAA;AA1BR;AA6BM;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AA3BR;AA+BI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,+BAAA;EACA,wCAAA;AA7BN;AA+BM;EACE,qBAAA;EACA,mBAAA;AA7BR;AAiCI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,8BAAA;AA/BN;AAoCE;EACE,WAAA;EACA,YAAA;EACA,qDAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yCAAA;EACA,yBAAA;EACA,kBAAA;AAlCJ;AAoCI;EACE,2BAAA;EACA,yCAAA;AAlCN;AAqCI;EACE,0CAAA;AAnCN;AAsCI;EACE,WAjHE;EAkHF,eAAA;AApCN;AAuCI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,WA1HE;EA2HF,kBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;AArCN;AA0CE;EACE,kBAAA;EACA,gBA1II;EA2IJ,mBAAA;EACA,yCAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,8BAAA;EACA,wDAAA;AAxCJ;AA0CI;EACE,2BAAA;EACA,YAAA;AAxCN;AA4CI;EACE,WAAA;EACA,WAAA;EACA,cAAA;AA1CN;AA6CI;EA7BF;IA8BI,sBAAA;IACA,uBAAA;IACA,YAAA;IACA,WAAA;EA1CJ;AACF;AA6CI;EACE,aAAA;EACA,yBAAA;EACA,WAAA;EACA,OAAA;EACA,gBAAA;EACA,+CAAA;AA3CN;AA6CM;EACE,SAAA;EACA,UAAA;AA3CR;AA+CM;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AA7CR;AAgDQ;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;AA9CV;AAoDI;EACE,qDAAA;EACA,WAlNE;EAmNF,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,sBAAA;AAlDN;AAoDM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAlDR;AAoDQ;EACE,eAAA;EACA,cAAA;AAlDV;AAqDQ;EACE,mBAAA;AAnDV;AA0DE;EACE,OAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAxDJ;AA2DI;EACE,UAAA;AAzDN;AA4DI;EACE,mBAAA;EACA,kBAAA;AA1DN;AA6DI;EACE,mBAAA;EACA,kBAAA;AA3DN;AA6DM;EACE,mBAAA;AA3DR;AAiEE;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,6BAAA;EACA,cAAA;AA/DJ;AAiEI;EACE,oBAAA;EACA,2BAAA;AA/DN;AAiEM;EACE,qDAAA;EACA,WA7RA;EA8RA,iCAAA;EACA,8CAAA;EACA,aAAA;AA/DR;AAkEM;EACE,mBA1SQ;AA0OhB;AAoEI;EACE,sBAAA;AAlEN;AAoEM;EACE,gBA5SA;EA6SA,WAhTK;EAiTL,yBAAA;EACA,iCAAA;EACA,yCAAA;AAlER;AAqEM;EACE,mBAAA;AAnER;AAuEI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AArEN;AAuEM;EACE,WAlUA;EAmUA,eAAA;AArER;AAyEI;EACE,kBAAA;EACA,qBAAA;EACA,4BAAA;AAvEN;AAyEM;EACE,SAAA;EACA,gBAAA;EACA,eAAA;AAvER;AA0EQ;EACE,eAAA;AAxEV;AAyEU;EACE,gBAAA;AAvEZ;AA2EQ;EACE,+BAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AAzEV;AA4EQ;EACE,sBAAA;EACA,+BAAA;EACA,gBAAA;EACA,kBAAA;AA1EV;AA6EQ;EACE,kBAAA;EACA,aAAA;AA3EV;AA+EM;EACE,eAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AA7ER;AAmFE;EACE,aAAA;EACA,mBAAA;AAjFJ;AAmFI;EACE,iBAAA;EACA,eAAA;EACA,WAAA;AAjFN;AAoFI;EACE,aAAA;EACA,QAAA;EACA,gBAAA;AAlFN;AAoFM;EACE,UAAA;EACA,WAAA;EACA,SAAA;EACA,mBAjZQ;EAkZR,kBAAA;EACA,YAAA;EACA,2CAAA;AAlFR;AAoFQ;EACE,mBAAA;AAlFV;AAqFQ;EACE,qBAAA;AAnFV;AAsFQ;EACE,qBAAA;AApFV;AA2FE;EACE,kBAAA;EACA,6BAAA;EACA,gBAnaI;EAoaJ,cAAA;EACA,2CAAA;EACA,kBAAA;EACA,WAAA;EACA,0BAAA;EACA,kCAAA;AAzFJ;AA2FI;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kFAAA;EACA,yBAAA;EACA,6BAAA;AAzFN;AA2FM;EACE,OAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;AAzFR;AA2FQ;EACE,aAAA;EACA,gBAAA;AAzFV;AA4FQ;EACE,mBAAA;EACA,mBAAA;EACA,4BAAA;EACA,YAAA;AA1FV;AA6FQ;EACE,cAAA;EACA,YAAA;AA3FV;AA+FM;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,qDAAA;EACA,YAAA;EACA,kBAAA;EACA,WAheA;EAieA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;EACA,wCAAA;AA7FR;AA+FQ;EACE,uBAAA;EACA,yCAAA;AA7FV;AAgGQ;EACE,sBAAA;EACA,wCAAA;AA9FV;AAiGQ;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;AA/FV;AAkGQ;EACE,eAAA;EACA,kBAAA;EACA,SAAA;AAhGV;AAqGM;EACE,kBAAA;AAnGR;AAqGQ;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AAnGV;AAqGU;EACE,cAAA;EACA,eAAA;AAnGZ;AAsGU;EACE,qDAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,uBAAA;AApGZ;AAsGY;EACE,uBAAA;AApGd;AA6GE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;AA3GJ;AA6GI;EACE,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;AA3GN;AA6GM;EACE,YAAA;AA3GR;AAiHI;EACE,2BAAA;AA/GN;;AAsHE;EACE,aAAA;AAnHJ;;AAyHE;EACE,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,gBAAA;EACA,wDAAA;AAtHJ;AAwHI;EACE,cAAA;AAtHN;AAyHI;EACE,UAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AAvHN;;AA6HA;EACE,0CAAA;EACA,8BAAA;AA1HF;AA6HI;EACE,cAznBU;AA8fhB;AA+HE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AA7HJ;AA+HI;EACE,gBAAA;EACA,WAjoBO;EAkoBP,kBAAA;AA7HN;;AAmIA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;AAhIF;AAmIE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAjIJ;AAmII;EACE,gBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;AAjIN;AAmIM;EACE,mBAAA;EACA,cAvqBQ;AAsiBhB;AAoIM;EACE,eAAA;EACA,cA5qBQ;EA6qBR,YAAA;AAlIR;AAqIM;EACE,eAAA;EACA,cAlrBQ;EAmrBR,YAAA;AAnIR;AAsIM;EACE,eAAA;AApIR;AAwII;EACE,cA5rBU;EA6rBV,aAAA;EACA,mBAAA;AAtIN;AAwIM;EACE,eAAA;AAtIR;;AA6IA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,2BAAA;AA1IF;AA4IE;EACE,iBAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;EACA,4BAAA;AA1IJ;AA4II;EACE,aAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AA1IN;AA4IM;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AA1IR;AA6IM;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA3IR;AA6IQ;EACE,mBAAA;AA3IV;AAgJI;EACE,aAAA;AA9IN;AAgJM;EACE,mBAAA;AA9IR;AAgJQ;EACE,mBAAA;AA9IV;AAiJQ;EACE,aAAA;EACA,QAAA;AA/IV;AAiJU;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,cA3xBI;EA4xBJ,UAAA;EACA,+BAAA;AA/IZ;AAiJY;EACE,qBAAA;AA/Id;AAkJY;EACE,cAnyBA;EAoyBA,0BAAA;AAhJd;AAuJQ;EACE,mBAAA;AArJV;AAwJQ;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;AAtJV;AAwJU;EACE,aAAA;EACA,qBAjzBI;EAkzBJ,6CAAA;AAtJZ;AA4JI;EACE,aAAA;EACA,0BAAA;EACA,aAAA;EACA,yBAAA;EACA,SAAA;AA1JN;AA4JM;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AA1JR;AA4JQ;EACE,mBAAA;EACA,sBAAA;EACA,WAAA;AA1JV;AA4JU;EACE,mBAAA;AA1JZ;AA8JQ;EACE,mBAl1BM;EAm1BN,yBAAA;EACA,YAAA;AA5JV;AA8JU;EACE,mBAt1BG;AA0rBf;AA+JU;EACE,YAAA;EACA,mBAAA;AA7JZ;AAgKU;EACE,kBAAA;EACA,kBAAA;AA9JZ;AAgKY;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;AA9Jd;;AAwKA;EACE;IACE,UAAA;IACA,2BAAA;EArKF;EAuKA;IACE,UAAA;IACA,wBAAA;EArKF;AACF;AAwKA;EACE;IAAO,UAAA;EArKP;EAsKA;IAAK,UAAA;EAnKL;AACF;AAqKA;EACE;IAAO,qBAAA;IAAuB,UAAA;EAjK9B;EAkKA;IAAK,mBAAA;IAAqB,UAAA;EA9J1B;AACF;AAgKA;EACE;IAAK,mBAAA;EA7JL;EA8JA;IAAM,qBAAA;EA3JN;EA4JA;IAAO,mBAAA;EAzJP;AACF;AA2JA;EACE;IACE,wBAAA;IACA,YAAA;EAzJF;EA2JA;IACE,2BAAA;IACA,UAAA;EAzJF;AACF;AA4JA;EACE;IAAW,uBAAA;EAzJX;EA0JA;IAA0B,wBAAA;EAvJ1B;EAwJA;IAAqB,uBAAA;EArJrB;AACF;AAuJA;EACE;IACE,UAAA;IACA,sCAAA;EArJF;EAuJA;IACE,uCAAA;EArJF;EAuJA;IACE,sCAAA;EArJF;EAuJA;IACE,UAAA;IACA,iCAAA;EArJF;AACF;AAwJA;EACE;IAAW,wBAAA;EArJX;EAsJA;IAAM,2BAAA;EAnJN;AACF;AAqJA;EACE;IAAW,UAAA;IAAY,mBAAA;EAjJvB;EAkJA;IAAM,YAAA;IAAc,qBAAA;EA9IpB;AACF;AAiJA;EACE;IACE,YAAA;IACA,WAAA;EA/IF;EAiJE;IACE,WAAA;IACA,YAAA;EA/IJ;EAiJI;IACE,eAAA;EA/IN;EAmJE;IACE,yBAAA;IACA,2BAAA;IACA,4BAAA;EAjJJ;AACF;AAsJA;EAEI;IACE,kBAAA;EArJJ;EAuJI;IACE,eAAA;EArJN;EAuJM;IACE,eAAA;EArJR;EAwJM;IACE,aAAA;EAtJR;EA0JI;IACE,QAAA;EAxJN;EA0JM;IACE,eAAA;IACA,YAAA;IACA,YAAA;EAxJR;EA0JQ;IACE,eAAA;EAxJV;EA8JE;IACE,QAAA;IACA,WAAA;EA5JJ;EA8JI;IACE,WAAA;IACA,YAAA;EA5JN;EA8JM;IACE,eAAA;EA5JR;AACF;AAkKA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,gCAAA;EACA,iBAAA;EACA,gBAAA;AAhKF;AAkKE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAxgCI;EAygCJ,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;AAhKJ;AAkKI;EACE,qBAzhCU;EA0hCV,wCAAA;AAhKN;AAkKM;EACE,UAAA;AAhKR;AAoKI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAlKN;AAoKM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAlKR;AAsKI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qDAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AApKN;AAsKM;EACE,eAAA;EACA,WAAA;AApKR;AAsKQ;EACE,cAAA;AApKV;AAuKQ;EACE,cAAA;AArKV;AAwKQ;EACE,cAAA;AAtKV;AAyKQ;EACE,cAAA;AAvKV;AA0KQ;EACE,cAAA;AAxKV;AA6KI;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA3KN;AA6KM;EACE,eAAA;EACA,gBAAA;EACA,WA1lCK;EA2lCL,mBAAA;EACA,gBAAA;EACA,uBAAA;AA3KR;AA8KM;EACE,eAAA;EACA,WAAA;AA5KR;AAgLI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WA5mCE;EA6mCF,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,yBAAA;EACA,wCAAA;AA9KN;AAgLM;EACE,mBAAA;EACA,qBAAA;AA9KR;AAiLM;EACE,eAAA;AA/KR;;AAqLA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;AAlLF;AAoLE;EACE,mCAAA;EACA,cAzpCY;AAu+BhB;AAqLE;EACE,sBAAA;AAnLJ;AAsLE;EACE,cAAA;EACA,mBAAA;AApLJ;AAuLE;EACE,eAAA;EACA,yBAAA;AArLJ;;AAyLA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;AAtLF;;AAyLA;EACE;IACE,iBAAA;EAtLF;EAwLE;IACE,gBAAA;IACA,gBAAA;IACA,gBAAA;EAtLJ;EAwLI;;IAEE,WAAA;IACA,YAAA;EAtLN;EA0LM;IACE,eAAA;EAxLR;EA2LM;IACE,cAAA;EAzLR;EA6LI;IACE,WAAA;IACA,YAAA;IACA,SAAA;IACA,WAAA;EA3LN;EA6LM;IACE,cAAA;EA3LR;EAiMA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EA/LF;EAiME;IACE,eAAA;EA/LJ;AACF;AAoMA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAruCM;EAsuCN,yBAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,WAAA;EACA,gCAAA;AAlMF;AAoME;EACE,iBAAA;EACA,gBAAA;AAlMJ;AAqMI;EACE,UAAA;AAnMN;AAsMI;EACE,uBAAA;AApMN;AAuMI;EACE,mBAAA;EACA,kBAAA;AArMN;AAyME;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;EACA,gCAAA;AAvMJ;AAyMI;EACE,mBAAA;AAvMN;AA0MI;EAEE,oCAAA;AAzMN;AA4MI;EACE,oCAAA;EACA,8BAAA;EACA,kBAAA;AA1MN;AA6MI;EACE,eAAA;EACA,cAhyCU;EAiyCV,cAAA;EACA,WAAA;EACA,kBAAA;AA3MN;AA8MI;EACE,eAAA;EACA,WAryCO;EAsyCP,gBAAA;EACA,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;AA5MN;AAgNE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;EACA,WAAA;AA9MJ;AAgNI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA9MN;AAiNI;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,gBAr0CE;EAs0CF,yBAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,WAAA;EACA,sCAAA;AA/MN;;AAqNA;EACE;IACE,UAAA;IACA,2BAAA;EAlNF;EAoNA;IACE,UAAA;IACA,wBAAA;EAlNF;AACF;AAuNE;EACE,kBAAA;AArNJ;;AA0NA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,2BAAA;EACA,0BAAA;EACA,kCAAA;AAvNF;AAyNE;EACE,gBAp3CI;EAq3CJ,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;AAvNJ;AAyNI;EACE,6DAAA;EACA,WAj4CE;EAk4CF,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;AAvNN;AAyNM;EACE,WAAA;EACA,YAAA;EACA,oCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAvNR;AAyNQ;EACE,eAAA;AAvNV;AA2NM;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,OAAA;AAzNR;AA4NM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,YAAA;EACA,kBAAA;EACA,WAv6CA;EAw6CA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AA1NR;AA4NQ;EACE,oCAAA;EACA,wBAAA;AA1NV;AA6NQ;EACE,eAAA;AA3NV;AAgOI;EACE,aAAA;EACA,gBAAA;EACA,OAAA;AA9NN;AAgOM;EACE,mBAAA;AA9NR;AAgOQ;EACE,eAAA;EACA,gBAAA;EACA,WAv8CG;EAw8CH,sFAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AA9NV;AAiOQ;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;AA/NV;AAoOQ;EACE,eAAA;EACA,gBAAA;EACA,WA39CG;EA49CH,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAlOV;AAoOU;EACE,cAr+CI;AAmwChB;AAsOQ;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AApOV;AAsOU;EACE,mBAAA;EACA,0BAAA;AApOZ;AAuOU;EACE,WAAA;EACA,YAAA;EACA,qDAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AArOZ;AAuOY;EACE,WA5/CN;EA6/CM,eAAA;AArOd;AAyOU;EACE,OAAA;AAvOZ;AAyOY;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,WA3gDD;AAoyCb;AA0OY;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAxOd;AA2OY;EACE,iBAAA;EACA,kBAAA;AAzOd;AA2Oc;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAzOhB;AAgPM;EACE,gBAAA;EACA,aAAA;EACA,qFAAA;EACA,mBAAA;EACA,kBAAA;AA9OR;AAgPQ;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,WA/iDG;AAi0Cb;AAiPQ;EACE,gBAAA;EACA,eAAA;EACA,WAAA;AA/OV;AAoPI;EACE,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,uBAAA;AAlPN;AAoPM;EACE,kBAAA;EACA,qDAAA;EACA,YAAA;EACA,mBAAA;EACA,WAlkDA;EAmkDA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,8CAAA;AAlPR;AAoPQ;EACE,2BAAA;EACA,8CAAA;AAlPV;AAqPQ;EACE,wBAAA;AAnPV;AAsPQ;EACE,eAAA;AApPV;;AA4PA;EAEI;IACE,UAAA;IACA,gBAAA;IACA,mBAAA;EA1PJ;EA4PI;IACE,kBAAA;EA1PN;EA4PM;IACE,WAAA;IACA,YAAA;EA1PR;EA4PQ;IACE,eAAA;EA1PV;EA8PM;IACE,eAAA;EA5PR;EAgQI;IACE,aAAA;EA9PN;EAiQQ;IACE,sBAAA;IACA,SAAA;EA/PV;EAiQU;IACE,WAAA;IACA,YAAA;EA/PZ;EAiQY;IACE,eAAA;EA/Pd;EAyQA;IACE,SAAA;IACA,UAAA;EAvQF;EAyQE;IACE,kBAAA;EAvQJ;EAyQI;IACE,eAAA;EAvQN;EA2QE;IACE,aAAA;EAzQJ;AACF","sourcesContent":["/* Wings Assistant Chat Component Styles */\n\n// Cores adicionais para feedback\n$star-inactive: #d0d0d0;\n$star-active: #ffc107;\n$rating-excellent: #4caf50;\n$rating-good: #8bc34a;\n$rating-neutral: #ffeb3b;\n$rating-bad: #ff9800;\n$rating-terrible: #f44336;\n\n// Variáveis de cores baseadas no projeto Wings\n$primary-color: #1ab394;\n$primary-dark: #13806a;\n$secondary-color: #ebebeb;\n$text-color: #333;\n$border-color: #d4d4d4;\n$background-light: #f5f5f5;\n$white: #fff;\n$shadow-color: rgba(0, 0, 0, 0.1);\n$shadow-color-strong: rgba(0, 0, 0, 0.2);\n\n// Z-index alto para garantir que o chat fique sobre outros elementos\n$chat-z-index: 9999;\n\n.wings-assistant-chat {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  z-index: $chat-z-index;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n\n  // Container do botão toggle com bubble\n  .chat-toggle-button-container {\n    position: relative;\n    display: inline-block;\n  }\n\n  // News Bubble (tooltip de novidades)\n  .news-bubble {\n    position: absolute;\n    bottom: 70px;\n    right: 0;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    padding: 12px 16px;\n    border-radius: 12px;\n    box-shadow: 0 4px 20px rgba(102, 126, 234, 0.4);\n    cursor: pointer;\n    animation: bounceIn 0.5s ease, floatBubble 3s ease-in-out infinite;\n    min-width: 220px;\n    max-width: 280px;\n    z-index: $chat-z-index + 10;\n\n    .news-bubble-content {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      \n      i {\n        font-size: 18px;\n        animation: sparkle 1.5s ease-in-out infinite;\n      }\n      \n      span {\n        font-size: 13px;\n        font-weight: 500;\n        line-height: 1.4;\n      }\n    }\n\n    .news-bubble-close {\n      position: absolute;\n      top: -8px;\n      right: -8px;\n      width: 22px;\n      height: 22px;\n      border-radius: 50%;\n      background: #ff4757;\n      border: 2px solid white;\n      color: white;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      font-size: 10px;\n      transition: transform 0.2s ease;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n\n      &:hover {\n        transform: scale(1.1);\n        background: #ff3344;\n      }\n    }\n\n    .news-bubble-arrow {\n      position: absolute;\n      bottom: -8px;\n      right: 25px;\n      width: 0;\n      height: 0;\n      border-left: 10px solid transparent;\n      border-right: 10px solid transparent;\n      border-top: 10px solid #764ba2;\n    }\n  }\n\n  // Botão toggle (modo compacto)\n  .chat-toggle-button {\n    width: 60px;\n    height: 60px;\n    background: linear-gradient(135deg, $primary-color, $primary-dark);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    box-shadow: 0 4px 20px $shadow-color-strong;\n    transition: all 0.3s ease;\n    position: relative;\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 6px 25px $shadow-color-strong;\n    }\n\n    &.shake-animation {\n      animation: shake 0.8s ease-in-out infinite;\n    }\n\n    i {\n      color: $white;\n      font-size: 24px;\n    }\n\n    .chat-badge {\n      position: absolute;\n      top: -5px;\n      right: -5px;\n      background: #ff4757;\n      color: $white;\n      border-radius: 50%;\n      min-width: 20px;\n      height: 20px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 12px;\n      font-weight: bold;\n      animation: pulse 2s infinite;\n    }\n  }\n\n  // Janela do chat (modo expandido)\n  .chat-window {\n    position: relative;\n    background: $white;\n    border-radius: 12px;\n    box-shadow: 0 8px 40px $shadow-color-strong;\n    width: 400px;\n    height: 600px;\n    min-width: 300px;\n    min-height: 50px;\n    max-width: 90vw;\n    max-height: 80vh;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    animation: slideInUp 0.3s ease;\n    transition: height 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);\n    \n    &.chat-resizing {\n      transition: none !important;\n      resize: both;\n    }\n\n    // Posicionamento de header global\n    wings-chat-header {\n      width: 100%;\n      z-index: 30;\n      flex-shrink: 0;\n    }\n\n    @media (max-width: 768px) {\n      width: 95vw !important;\n      height: 70vh !important;\n      bottom: 10px;\n      right: 10px;\n    }\n    \n    // Layout do chat (estrutura do conteúdo)\n    .chat-layout {\n      display: flex;\n      height: calc(100% - 50px);\n      width: 100%;\n      flex: 1;\n      overflow: hidden;\n      transition: opacity 0.3s ease, height 0.3s ease;\n      \n      &.minimized {\n        height: 0; \n        opacity: 0;\n      }\n      \n      // Área principal do chat (ao lado da barra de conversas)\n      .chat-main {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n        overflow: hidden;\n        position: relative;\n\n        // Chat content layout fix\n        .chat-content {\n          flex: 1;\n          display: flex;\n          flex-direction: column;\n          overflow: hidden;\n          background-color: #fafafa;\n          width: 100%;\n          position: relative;\n        }\n      }\n    }\n\n    // Header do chat\n    .chat-header {\n      background: linear-gradient(135deg, $primary-color, $primary-dark);\n      color: $white;\n      padding: 16px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      min-height: 50px;\n      height: 50px;\n      flex-shrink: 0;\n      width: 100%;\n      box-sizing: border-box;\n\n      .chat-title {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        font-weight: 600;\n        font-size: 16px;\n        flex-shrink: 0;\n\n        i {\n          font-size: 18px;\n          flex-shrink: 0;\n        }\n\n        span {\n          white-space: nowrap;\n        }\n      }\n    }\n  }\n\n  // Container de mensagens\n  .chat-messages {\n    flex: 1;\n    padding: 16px;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    background: #fafafa;\n\n    // Customizar scrollbar\n    &::-webkit-scrollbar {\n      width: 6px;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: #f1f1f1;\n      border-radius: 3px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: #c1c1c1;\n      border-radius: 3px;\n\n      &:hover {\n        background: #a1a1a1;\n      }\n    }\n  }\n\n  // Mensagem individual\n  .message {\n    display: flex;\n    gap: 12px;\n    align-items: flex-start;\n    animation: fadeInUp 0.3s ease;\n    max-width: 90%;\n    \n    &.user-message {\n      align-self: flex-end;\n      flex-direction: row-reverse;\n\n      .message-content {\n        background: linear-gradient(135deg, $primary-color, $primary-dark);\n        color: $white;\n        border-radius: 18px 18px 4px 18px;\n        box-shadow: 0 2px 8px rgba($primary-dark, 0.25);\n        padding: 10px;\n      }\n\n      .message-avatar {\n        background: $primary-color;\n      }\n    }\n\n    &.assistant-message {\n      align-self: flex-start;\n      \n      .message-content {\n        background: $white;\n        color: $text-color;\n        border: 1px solid #e1e5e9;\n        border-radius: 18px 18px 18px 4px;\n        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n      }\n\n      .message-avatar {\n        background: #6c757d;\n      }\n    }\n\n    .message-avatar {\n      width: 36px;\n      height: 36px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-shrink: 0;\n\n      i {\n        color: $white;\n        font-size: 16px;\n      }\n    }\n\n    .message-content {\n      padding: 12px 16px;\n      word-wrap: break-word;\n      max-width: calc(100% - 48px);\n\n      .message-text {\n        margin: 0;\n        line-height: 1.5;\n        font-size: 14px;\n        \n        // Style for rendered markdown content\n        p {\n          margin: 0 0 8px;\n          &:last-child {\n            margin-bottom: 0;\n          }\n        }\n        \n        pre {\n          background: rgba(0, 0, 0, 0.05);\n          padding: 8px;\n          border-radius: 6px;\n          overflow-x: auto;\n          margin: 8px 0;\n        }\n        \n        code {\n          font-family: monospace;\n          background: rgba(0, 0, 0, 0.05);\n          padding: 2px 4px;\n          border-radius: 3px;\n        }\n        \n        ul, ol {\n          padding-left: 24px;\n          margin: 8px 0;\n        }\n      }\n\n      .message-time {\n        font-size: 11px;\n        opacity: 0.7;\n        margin-top: 6px;\n        text-align: right;\n      }\n    }\n  }\n\n  // Indicador de digitação\n  .typing-indicator {\n    display: flex;\n    align-items: center;\n    \n    span {\n      margin-right: 8px;\n      font-size: 13px;\n      color: #666;\n    }\n    \n    .typing-dots {\n      display: flex;\n      gap: 4px;\n      padding: 4px 8px;\n\n      span {\n        width: 8px;\n        height: 8px;\n        margin: 0;\n        background: $primary-color;\n        border-radius: 50%;\n        opacity: 0.7;\n        animation: typing 1.4s infinite ease-in-out;\n\n        &:nth-child(1) {\n          animation-delay: 0s;\n        }\n        \n        &:nth-child(2) {\n          animation-delay: 0.2s;\n        }\n\n        &:nth-child(3) {\n          animation-delay: 0.4s;\n        }\n      }\n    }\n  }\n\n  // Área de input\n  .chat-input {\n    padding: 12px 16px;\n    border-top: 1px solid #e1e5e9;\n    background: $white;\n    flex-shrink: 0;\n    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.03);\n    position: relative;\n    z-index: 10;\n    backdrop-filter: blur(5px);\n    -webkit-backdrop-filter: blur(5px);\n\n    .input-container, .input-container-chat {\n      display: flex;\n      gap: 8px;\n      align-items: center;\n      background: #f8f9fa;\n      border-radius: 24px;\n      padding: 6px 6px 6px 16px;\n      box-shadow: 0 3px 12px rgba(0, 0, 0, 0.06), inset 0 1px 0 rgba(255, 255, 255, 0.9);\n      border: 1px solid #e0e4e8;\n      transition: all 0.2s ease-out;\n\n      textarea.message-input {\n        flex: 1;\n        padding: 10px 12px;\n        border: none;\n        border-radius: 24px;\n        outline: none;\n        resize: none;\n        font-size: 14px;\n        min-height: 20px;\n        max-height: 100px;\n        overflow-y: auto;\n        font-family: inherit;\n        line-height: 1.4;\n        background: transparent;\n        margin: 0;\n        align-self: center;\n        \n        &:focus {\n          outline: none;\n          box-shadow: none;\n        }\n\n        &:disabled {\n          background: #f9f9f9;\n          cursor: not-allowed;\n          border-radius: 24px 0 0 24px;\n          opacity: 0.7;\n        }\n\n        &::placeholder {\n          color: #9ca3af;\n          opacity: 0.8;\n        }\n      }\n\n      .send-button {\n        width: 40px;\n        height: 40px;\n        min-width: 40px;\n        background: linear-gradient(135deg, $primary-color, $primary-dark);\n        border: none;\n        border-radius: 50%;\n        color: $white;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-shrink: 0;\n        margin-right: 4px;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n        \n        &:hover:not(:disabled) {\n          filter: brightness(1.1);\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n        }\n        \n        &:active:not(:disabled) {\n          transform: scale(0.95);\n          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n        }\n\n        &:disabled {\n          background: #d1d5db;\n          cursor: not-allowed;\n          box-shadow: none;\n        }\n\n        i {\n          font-size: 16px;\n          position: relative;\n          left: 1px;\n        }\n      }\n\n      // Expired conversation state\n      &.expired {\n        position: relative;\n\n        .expired-overlay {\n          position: absolute;\n          top: 0;\n          left: 0;\n          right: 0;\n          bottom: 0;\n          background: rgba(255, 255, 255, 0.95);\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          gap: 8px;\n          z-index: 5;\n          border-radius: 24px;\n          padding: 6px 12px;\n          font-size: 13px;\n          color: #6b7280;\n\n          i.fa-clock-o {\n            color: #f59e0b;\n            font-size: 15px;\n          }\n\n          .expired-new-chat-btn {\n            background: linear-gradient(135deg, #3b82f6, #2563eb);\n            color: #fff;\n            border: none;\n            border-radius: 16px;\n            padding: 4px 12px;\n            font-size: 12px;\n            cursor: pointer;\n            display: flex;\n            align-items: center;\n            gap: 4px;\n            white-space: nowrap;\n            transition: filter 0.2s;\n\n            &:hover {\n              filter: brightness(1.1);\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // Estados de tela cheia\n  &.chat-fullscreen {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: $chat-z-index + 1;\n\n    .chat-window {\n      width: 100% !important;\n      height: 100% !important;\n      max-width: none !important;\n      max-height: none !important;\n      border-radius: 0 !important;\n      box-shadow: none !important;\n      \n      .chat-layout {\n        height: 100%;\n      }\n    }\n  }\n\n  &.chat-resizing {\n    .chat-window {\n      transition: none !important;\n    }\n  }\n}\n\n// Estado quando o chat está aberto\n.wings-assistant-chat.chat-open {\n  .chat-toggle-button {\n    display: none;\n  }\n}\n\n// Estado quando o chat está minimizado\n.wings-assistant-chat.chat-minimized {\n  .chat-window {\n    height: 64px !important;\n    min-height: 64px !important;\n    max-height: 64px !important;\n    overflow: hidden;\n    transition: height 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);\n\n    wings-chat-header {\n      display: block;\n    }\n\n    .chat-layout {\n      opacity: 0;\n      height: 0;\n      overflow: hidden;\n      visibility: hidden;\n    }\n  }\n}\n\n// Estilo para mensagem do sistema (como indicadores de carregamento)\n.system-message {\n  background-color: rgba($primary-color, 0.05);\n  border-left: 3px solid $primary-color;\n  \n  .message-avatar {\n    i {\n      color: $primary-color;\n    }\n  }\n  \n  .loading-indicator {\n    display: flex;\n    align-items: center;\n    padding: 5px;\n    \n    span {\n      margin-left: 8px;\n      color: $text-color;\n      font-style: italic;\n    }\n  }\n}\n\n// Estilos para o componente de feedback nas mensagens\n.message-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 6px;\n  font-size: 12px;\n  \n  \n  .message-feedback {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    \n    .feedback-button {\n      background: none;\n      border: none;\n      color: #777;\n      font-size: 12px;\n      padding: 4px 8px;\n      border-radius: 12px;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      gap: 4px;\n      transition: all 0.2s ease;\n      \n      &:hover:not(.disabled) {\n        background: #f0f0f0;\n        color: $primary-color;\n      }\n      \n      &.disabled {\n        cursor: default;\n        color: $primary-color;\n        opacity: 0.8;\n      }\n      \n      &:disabled {\n        cursor: default;\n        color: $primary-color;\n        opacity: 0.8;\n      }\n      \n      i {\n        font-size: 14px;\n      }\n    }\n    \n    .feedback-sent {\n      color: $primary-color;\n      display: flex;\n      align-items: center;\n      \n      i {\n        font-size: 14px;\n      }\n    }\n  }\n}\n\n// Modal de feedback\n.feedback-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: $chat-z-index + 100;\n  animation: fadeIn 0.2s ease;\n  \n  .feedback-modal-content {\n    background: white;\n    border-radius: 12px;\n    width: 90%;\n    max-width: 400px;\n    max-height: 90vh;\n    overflow-y: auto;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n    animation: scaleIn 0.2s ease;\n    \n    .feedback-modal-header {\n      padding: 16px;\n      border-bottom: 1px solid #eee;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      \n      h2 {\n        margin: 0;\n        font-size: 18px;\n        font-weight: 600;\n      }\n      \n      .close-button {\n        background: none;\n        border: none;\n        font-size: 18px;\n        cursor: pointer;\n        color: #777;\n        width: 30px;\n        height: 30px;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        \n        &:hover {\n          background: #f5f5f5;\n        }\n      }\n    }\n    \n    .feedback-modal-body {\n      padding: 16px;\n      \n      .feedback-rating {\n        margin-bottom: 20px;\n        \n        p {\n          margin-bottom: 10px;\n        }\n        \n        .star-rating {\n          display: flex;\n          gap: 8px;\n          \n          .star-button {\n            background: none;\n            border: none;\n            font-size: 24px;\n            cursor: pointer;\n            color: $star-inactive;\n            padding: 0;\n            transition: transform 0.2s ease;\n            \n            &:hover {\n              transform: scale(1.2);\n            }\n            \n            &.active {\n              color: $star-active;\n              animation: pulse 0.3s ease;\n            }\n          }\n        }\n      }\n      \n      .feedback-comment {\n        p {\n          margin-bottom: 10px;\n        }\n        \n        .feedback-textarea {\n          width: 100%;\n          padding: 10px;\n          border: 1px solid #ddd;\n          border-radius: 8px;\n          font-family: inherit;\n          resize: vertical;\n          \n          &:focus {\n            outline: none;\n            border-color: $primary-color;\n            box-shadow: 0 0 0 2px rgba($primary-color, 0.2);\n          }\n        }\n      }\n    }\n    \n    .feedback-modal-footer {\n      padding: 16px;\n      border-top: 1px solid #eee;\n      display: flex;\n      justify-content: flex-end;\n      gap: 10px;\n      \n      button {\n        padding: 8px 16px;\n        border-radius: 4px;\n        font-weight: 500;\n        font-size: 14px;\n        cursor: pointer;\n        transition: all 0.2s ease;\n        \n        &.cancel-button {\n          background: #f5f5f5;\n          border: 1px solid #ddd;\n          color: #333;\n          \n          &:hover {\n            background: #e5e5e5;\n          }\n        }\n        \n        &.submit-button {\n          background: $primary-color;\n          border: 1px solid $primary-dark;\n          color: white;\n          \n          &:hover {\n            background: $primary-dark;\n          }\n          \n          &:disabled {\n            opacity: 0.6;\n            cursor: not-allowed;\n          }\n          \n          &.loading {\n            position: relative;\n            padding-left: 30px;\n            \n            i {\n              position: absolute;\n              left: 10px;\n              top: 50%;\n              transform: translateY(-50%);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n// Animações\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes scaleIn {\n  from { transform: scale(0.9); opacity: 0; }\n  to { transform: scale(1); opacity: 1; }\n}\n\n@keyframes pulse {\n  0% { transform: scale(1); }\n  50% { transform: scale(1.2); }\n  100% { transform: scale(1); }\n}\n\n@keyframes typing {\n  0%, 100% {\n    transform: translateY(0);\n    opacity: 0.6;\n  }\n  50% {\n    transform: translateY(-6px);\n    opacity: 1;\n  }\n}\n\n@keyframes shake {\n  0%, 100% { transform: rotate(0deg); }\n  10%, 30%, 50%, 70%, 90% { transform: rotate(-5deg); }\n  20%, 40%, 60%, 80% { transform: rotate(5deg); }\n}\n\n@keyframes bounceIn {\n  0% {\n    opacity: 0;\n    transform: scale(0.3) translateY(20px);\n  }\n  50% {\n    transform: scale(1.05) translateY(-5px);\n  }\n  70% {\n    transform: scale(0.95) translateY(2px);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n@keyframes floatBubble {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-5px); }\n}\n\n@keyframes sparkle {\n  0%, 100% { opacity: 1; transform: scale(1); }\n  50% { opacity: 0.7; transform: scale(1.1); }\n}\n\n// Estados responsivos adicionais\n@media (max-width: 480px) {\n  .wings-assistant-chat {\n    bottom: 10px;\n    right: 10px;\n\n    .chat-toggle-button {\n      width: 56px;\n      height: 56px;\n\n      i {\n        font-size: 22px;\n      }\n    }\n\n    .chat-window {\n      width: calc(100vw - 20px);\n      height: calc(100vh - 100px);\n      border-radius: 12px 12px 0 0;\n    }\n  }\n}\n\n// Melhorias para responsividade dos ícones\n@media (max-width: 600px) {\n  .wings-assistant-chat {\n    .chat-header {\n      padding: 12px 16px;\n\n      .chat-title {\n        font-size: 14px;\n\n        i {\n          font-size: 16px;\n        }\n\n        span {\n          display: none;\n        }\n      }\n\n      .chat-actions {\n        gap: 4px;\n\n        .action-btn {\n          min-width: 28px;\n          height: 28px;\n          padding: 4px;\n\n          i {\n            font-size: 12px;\n          }\n        }\n      }\n    }\n    \n    .chat-controls {\n      top: 8px;\n      right: 12px;\n      \n      .control-btn {\n        width: 28px;\n        height: 28px;\n        \n        i {\n          font-size: 12px;\n        }\n      }\n    }\n  }\n}\n\n.attachments-preview {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 8px 12px;\n  background: #f8f9fa;\n  border-bottom: 1px solid #e1e5e9;\n  max-height: 150px;\n  overflow-y: auto;\n\n  .attachment-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background: $white;\n    border: 1px solid #e1e5e9;\n    border-radius: 8px;\n    padding: 6px 10px;\n    max-width: 200px;\n    min-width: 120px;\n    position: relative;\n    transition: all 0.2s ease;\n    animation: fadeInUp 0.2s ease;\n\n    &:hover {\n      border-color: $primary-color;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n\n      .attachment-remove {\n        opacity: 1;\n      }\n    }\n\n    .attachment-thumbnail {\n      width: 32px;\n      height: 32px;\n      border-radius: 4px;\n      overflow: hidden;\n      flex-shrink: 0;\n\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n    }\n\n    .attachment-icon {\n      width: 32px;\n      height: 32px;\n      border-radius: 4px;\n      background: linear-gradient(135deg, #f0f0f0, #e0e0e0);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-shrink: 0;\n\n      i {\n        font-size: 16px;\n        color: #666;\n\n        &.fa-file-pdf-o {\n          color: #e74c3c;\n        }\n\n        &.fa-file-excel-o {\n          color: #27ae60;\n        }\n\n        &.fa-file-word-o {\n          color: #2980b9;\n        }\n\n        &.fa-file-image-o {\n          color: #9b59b6;\n        }\n\n        &.fa-file-text-o {\n          color: #7f8c8d;\n        }\n      }\n    }\n\n    .attachment-info {\n      flex: 1;\n      min-width: 0;\n      display: flex;\n      flex-direction: column;\n      gap: 2px;\n\n      .attachment-name {\n        font-size: 12px;\n        font-weight: 500;\n        color: $text-color;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      .attachment-size {\n        font-size: 10px;\n        color: #999;\n      }\n    }\n\n    .attachment-remove {\n      position: absolute;\n      top: -6px;\n      right: -6px;\n      width: 20px;\n      height: 20px;\n      border-radius: 50%;\n      background: #ff4757;\n      border: 2px solid $white;\n      color: $white;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      opacity: 0;\n      transition: all 0.2s ease;\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n\n      &:hover {\n        background: #ff3344;\n        transform: scale(1.1);\n      }\n\n      i {\n        font-size: 10px;\n      }\n    }\n  }\n}\n\n.attachment-button {\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n  background: transparent;\n  border: none;\n  border-radius: 50%;\n  color: #6b7280;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: all 0.2s ease;\n  margin-right: 4px;\n\n  &:hover:not(:disabled) {\n    background: rgba($primary-color, 0.1);\n    color: $primary-color;\n  }\n\n  &:active:not(:disabled) {\n    transform: scale(0.95);\n  }\n\n  &:disabled {\n    color: #d1d5db;\n    cursor: not-allowed;\n  }\n\n  i {\n    font-size: 18px;\n    transform: rotate(-45deg);\n  }\n}\n\n.hidden-file-input {\n  position: absolute;\n  width: 0;\n  height: 0;\n  opacity: 0;\n  pointer-events: none;\n}\n\n@media (max-width: 480px) {\n  .attachments-preview {\n    max-height: 120px;\n    \n    .attachment-item {\n      max-width: 160px;\n      min-width: 100px;\n      padding: 4px 8px;\n\n      .attachment-thumbnail,\n      .attachment-icon {\n        width: 28px;\n        height: 28px;\n      }\n\n      .attachment-info {\n        .attachment-name {\n          font-size: 11px;\n        }\n\n        .attachment-size {\n          font-size: 9px;\n        }\n      }\n\n      .attachment-remove {\n        width: 18px;\n        height: 18px;\n        top: -5px;\n        right: -5px;\n\n        i {\n          font-size: 9px;\n        }\n      }\n    }\n  }\n\n  .attachment-button {\n    width: 32px;\n    height: 32px;\n    min-width: 32px;\n\n    i {\n      font-size: 16px;\n    }\n  }\n}\n\n// === Dropdown de Sugestões Autocomplete ===\n.suggestions-dropdown {\n  position: absolute;\n  bottom: 100%;\n  left: 16px;\n  right: 16px;\n  margin-bottom: 8px;\n  background: $white;\n  border: 1px solid #e1e5e9;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  overflow: hidden;\n  z-index: 20;\n  animation: slideUpFade 0.2s ease;\n\n  .suggestions-list {\n    max-height: 200px;\n    overflow-y: auto;\n\n    // Scrollbar customizada\n    &::-webkit-scrollbar {\n      width: 4px;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: transparent;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: #d0d0d0;\n      border-radius: 2px;\n    }\n  }\n\n  .suggestion-item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 12px 16px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    border-bottom: 1px solid #f0f0f0;\n\n    &:last-child {\n      border-bottom: none;\n    }\n\n    &:hover,\n    &.selected {\n      background: rgba($primary-color, 0.08);\n    }\n\n    &.selected {\n      background: rgba($primary-color, 0.12);\n      border-left: 3px solid $primary-color;\n      padding-left: 13px;\n    }\n\n    i {\n      font-size: 14px;\n      color: $primary-color;\n      flex-shrink: 0;\n      width: 20px;\n      text-align: center;\n    }\n\n    .suggestion-text {\n      font-size: 13px;\n      color: $text-color;\n      line-height: 1.4;\n      flex: 1;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      line-clamp: 2;\n      -webkit-box-orient: vertical;\n    }\n  }\n\n  .suggestions-hint {\n    display: flex;\n    justify-content: center;\n    gap: 16px;\n    padding: 8px 12px;\n    background: #f8f9fa;\n    border-top: 1px solid #e1e5e9;\n    font-size: 11px;\n    color: #888;\n\n    span {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n    }\n\n    kbd {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      min-width: 18px;\n      height: 18px;\n      padding: 0 4px;\n      background: $white;\n      border: 1px solid #d0d0d0;\n      border-radius: 4px;\n      font-family: inherit;\n      font-size: 10px;\n      color: #555;\n      box-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);\n    }\n  }\n}\n\n// Animação para o dropdown\n@keyframes slideUpFade {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n// Posicionar o chat-input como relativo para o dropdown\n.chat-content {\n  .chat-input {\n    position: relative;\n  }\n}\n\n// === Modal de Novidades ===\n.news-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: $chat-z-index + 200;\n  animation: fadeIn 0.3s ease;\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n\n  .news-modal {\n    background: $white;\n    border-radius: 16px;\n    width: 90%;\n    max-width: 550px;\n    max-height: 85vh;\n    overflow: hidden;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n    animation: scaleIn 0.3s ease;\n    display: flex;\n    flex-direction: column;\n\n    .news-modal-header {\n      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n      color: $white;\n      padding: 20px 24px;\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      position: relative;\n      color: white !important;\n      \n      .news-header-icon {\n        width: 48px;\n        height: 48px;\n        background: rgba(255, 255, 255, 0.2);\n        border-radius: 12px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        i {\n          font-size: 24px;\n        }\n      }\n\n      h2 {\n        margin: 0;\n        font-size: 20px;\n        font-weight: 600;\n        flex: 1;\n      }\n\n      .news-modal-close {\n        position: absolute;\n        top: 12px;\n        right: 12px;\n        width: 32px;\n        height: 32px;\n        background: rgba(255, 255, 255, 0.2);\n        border: none;\n        border-radius: 50%;\n        color: $white;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        transition: all 0.2s ease;\n\n        &:hover {\n          background: rgba(255, 255, 255, 0.3);\n          transform: rotate(90deg);\n        }\n\n        i {\n          font-size: 14px;\n        }\n      }\n    }\n\n    .news-modal-body {\n      padding: 24px;\n      overflow-y: auto;\n      flex: 1;\n\n      .news-intro {\n        margin-bottom: 24px;\n\n        .news-highlight {\n          font-size: 15px;\n          line-height: 1.6;\n          color: $text-color;\n          background: linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1));\n          padding: 16px;\n          border-radius: 12px;\n          border-left: 4px solid #667eea;\n          margin-bottom: 12px;\n        }\n\n        p {\n          font-size: 14px;\n          line-height: 1.6;\n          color: #555;\n          margin: 0;\n        }\n      }\n\n      .news-section {\n        h3 {\n          font-size: 16px;\n          font-weight: 600;\n          color: $text-color;\n          margin: 0 0 16px 0;\n          display: flex;\n          align-items: center;\n          gap: 8px;\n\n          i {\n            color: $primary-color;\n          }\n        }\n\n        .news-feature {\n          display: flex;\n          gap: 16px;\n          margin-bottom: 20px;\n          padding: 16px;\n          background: #f9fafb;\n          border-radius: 12px;\n          transition: all 0.2s ease;\n\n          &:hover {\n            background: #f3f4f6;\n            transform: translateX(4px);\n          }\n\n          .feature-icon {\n            width: 44px;\n            height: 44px;\n            background: linear-gradient(135deg, $primary-color, $primary-dark);\n            border-radius: 10px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            flex-shrink: 0;\n\n            i {\n              color: $white;\n              font-size: 18px;\n            }\n          }\n\n          .feature-content {\n            flex: 1;\n\n            h4 {\n              margin: 0 0 8px 0;\n              font-size: 14px;\n              font-weight: 600;\n              color: $text-color;\n            }\n\n            p {\n              margin: 0;\n              font-size: 13px;\n              line-height: 1.5;\n              color: #666;\n            }\n\n            ul {\n              margin: 8px 0 0 0;\n              padding-left: 20px;\n\n              li {\n                font-size: 12px;\n                color: #666;\n                line-height: 1.6;\n                margin-bottom: 4px;\n              }\n            }\n          }\n        }\n      }\n\n      .news-cta {\n        margin-top: 20px;\n        padding: 16px;\n        background: linear-gradient(135deg, rgba($primary-color, 0.1), rgba($primary-dark, 0.1));\n        border-radius: 12px;\n        text-align: center;\n\n        p {\n          margin: 0 0 8px 0;\n          font-size: 14px;\n          line-height: 1.5;\n          color: $text-color;\n        }\n\n        .news-signature {\n          margin-top: 12px;\n          font-size: 14px;\n          color: #666;\n        }\n      }\n    }\n\n    .news-modal-footer {\n      padding: 16px 24px;\n      border-top: 1px solid #e1e5e9;\n      display: flex;\n      justify-content: center;\n\n      .news-start-button {\n        padding: 12px 32px;\n        background: linear-gradient(135deg, $primary-color, $primary-dark);\n        border: none;\n        border-radius: 25px;\n        color: $white;\n        font-size: 15px;\n        font-weight: 600;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        transition: all 0.3s ease;\n        box-shadow: 0 4px 15px rgba($primary-color, 0.4);\n\n        &:hover {\n          transform: translateY(-2px);\n          box-shadow: 0 6px 20px rgba($primary-color, 0.5);\n        }\n\n        &:active {\n          transform: translateY(0);\n        }\n\n        i {\n          font-size: 18px;\n        }\n      }\n    }\n  }\n}\n\n// Responsivo para modal de novidades\n@media (max-width: 480px) {\n  .news-modal-overlay {\n    .news-modal {\n      width: 95%;\n      max-height: 90vh;\n      border-radius: 12px;\n\n      .news-modal-header {\n        padding: 16px 20px;\n\n        .news-header-icon {\n          width: 40px;\n          height: 40px;\n\n          i {\n            font-size: 20px;\n          }\n        }\n\n        h2 {\n          font-size: 16px;\n        }\n      }\n\n      .news-modal-body {\n        padding: 16px;\n\n        .news-section {\n          .news-feature {\n            flex-direction: column;\n            gap: 12px;\n\n            .feature-icon {\n              width: 36px;\n              height: 36px;\n\n              i {\n                font-size: 16px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // Sugestões em mobile\n  .suggestions-dropdown {\n    left: 8px;\n    right: 8px;\n\n    .suggestion-item {\n      padding: 10px 12px;\n\n      .suggestion-text {\n        font-size: 12px;\n      }\n    }\n\n    .suggestions-hint {\n      display: none; // Ocultar dicas de teclado em mobile\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
